import type { Lens } from '@dhmk/zustand-lens';
import type { OpportunitySummary } from '@/data-store/redux/slices/authSlice.types';

export type BatteryEcommState = {
  selectedOpportunity: OpportunitySummary | undefined;
};

export type BatteryEcommActions = {
  setSelectedOpportunity: (opportunity: OpportunitySummary | undefined) => void;
};

export type BatteryEcommSlice = BatteryEcommState & {
  actions: BatteryEcommActions;
};

const defaultValues: BatteryEcommState = {
  selectedOpportunity: undefined,
};

const sliceName = 'batteryEcomm';

export const createBatteryEcommSlice: Lens<BatteryEcommSlice> = (set) => ({
  ...defaultValues,
  actions: {
    setSelectedOpportunity: (selectedOpportunity) =>
      set(
        { selectedOpportunity },
        undefined,
        `${sliceName}/setSelectedOpportunity`
      ),
  },
});
